import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';
import lazyLoad from './script/lazyLoad';
import sliders from './script/slider';
import mobMenu from './script/mobMenu';
import dropdown from './script/dropdowns';
import readMore from './script/readmore';
import accordian from './script/accordian';
import headerPopups from './script/headerPopups';
import lineMove from './script/lineMove';
import stickyHeader from './script/stickyHeader';
import './script/popupCalls';

addEvent();
appHeight();
lazyLoad.init();
sliders.init();
mobMenu.init();
dropdown.init();
readMore.init();
accordian.init();
headerPopups.init();
lineMove.init();
stickyHeader.init();